import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _defineProperty from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "label", "type", "disabled", "invalid", "hideLabel", "error", "required", "icon", "id"];
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import { forwardRef, useMemo, cloneElement } from 'react';
import { useUniqueId } from '../../utils/useUniqueId.js';
import { InlineError } from '../inline-error/inline-error.js';
import styles from './base-text-input.module.js';
import { useLabelable } from '../../util-components/labelable/useLabelable.js';
/**
 * This extends a default HTML &lt;input/&gt; and accepts the same props as well as some custom ones listed below.<br/>
 *
 * **IMPORTANT **: Since input uses tooltip to display error message, it must be placed inside a single <b>TooltipProvider</b> component provided by the app, see [issue on github](https://github.com/radix-ui/primitives/issues/1712) and [radix docs](https://www.radix-ui.com/docs/primitives/components/tooltip#provider).
 *
 */

var BaseTextInput = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  var _clsx2;

  var className = props.className,
      label = props.label,
      _props$type = props.type,
      type = _props$type === void 0 ? 'text' : _props$type,
      disabled = props.disabled,
      _props$invalid = props.invalid,
      invalid = _props$invalid === void 0 ? false : _props$invalid,
      hideLabel = props.hideLabel,
      error = props.error,
      _props$required = props.required,
      required = _props$required === void 0 ? false : _props$required,
      icon = props.icon,
      id = props.id,
      rest = _objectWithoutProperties(props, _excluded);

  var uniqueId = useUniqueId('input-');
  var inputId = id || uniqueId;
  var inlineErrorId = useUniqueId('inline-error-');
  var hasError = !!error && !disabled;
  var shouldMarkError = (!!error || invalid) && !disabled;
  var ariaDescribedBy = clsx(rest['aria-describedby'], _defineProperty({}, inlineErrorId, hasError));
  var IconComponent = useMemo(function () {
    var _icon$props;

    return icon && /*#__PURE__*/cloneElement(icon, {
      className: clsx((_icon$props = icon.props) === null || _icon$props === void 0 ? void 0 : _icon$props.className, styles.iconShared)
    });
  }, [icon]);
  var Label = useLabelable(label, inputId);
  return jsxs(Fragment, {
    children: [jsxs("div", {
      className: clsx([styles.textInputContainer], (_clsx2 = {}, _defineProperty(_clsx2, styles.disabled, disabled), _defineProperty(_clsx2, styles.error, shouldMarkError), _clsx2), className),
      children: [jsx(Label, {
        className: clsx([styles.label], _defineProperty({}, styles.hidden, hideLabel)),
        hideLabel: hideLabel
      }), jsx("input", _objectSpread(_objectSpread({}, rest), {}, {
        ref: forwardedRef,
        "aria-describedby": ariaDescribedBy,
        "aria-invalid": shouldMarkError,
        "aria-required": required,
        className: clsx([styles.textInput], _defineProperty({}, styles.error, shouldMarkError)),
        disabled: disabled,
        id: inputId,
        required: required,
        type: type
      })), IconComponent]
    }), jsx(InlineError, {
      className: styles.inlineError,
      id: inlineErrorId,
      children: error
    })]
  });
});
export { BaseTextInput };